// extracted by mini-css-extract-plugin
export default {"not-found":"not-found_not-found__7x8wX","not-found-title":"not-found_not-found-title__d9tQd","not-found-message":"not-found_not-found-message__6SDCz"};